<div class="pr-3 pl-4 h-full w-full overflow-auto" (window:resize)="checkHeight()">
  <div nz-row [nzGutter]="[0,0]" class="h-full pt-6">
    <div nz-col nzSm="8" nzMd="8" nzLg="5" nzXl="4" class="mailleftmenu">
      <div nz-row [nzGutter]="[0,0]" class="h-full menu" [style.height.px]="heightMenu">
        <div nz-col nzSpan="24">
          <button class="mail-btn" nz-button [nzSize]="'large'" nzType="primary" (click)="openNewMail()">
            <i nz-icon nzType="edit" nzTheme="outline"></i>&nbsp;Soạn thư
          </button>
        </div>
        <div nz-col nzSpan="24" class="menu-mail h-full">
          <ul nz-menu nzMode="inline" class="h-full overflow-y-auto overflow-x-hidden leftmenumailbox">
            <li nz-menu-item nzSelected (click)="changeModeInbox('inbox',{id : 0})">
              <i class="fas fa-inbox"></i>
              Hộp thư đến
              <nz-badge [nzCount]="inboxUnread" class="badge"></nz-badge>
            </li>
            <li nz-menu-item (click)="changeMode('outbox')">
              <i nz-icon nzType="send"></i>
              Thư đã gửi
            </li>
            <li nz-menu-item (click)="changeMode('draft')">
              <i nz-icon nzType="radius-upleft"></i>
              Thư nháp
              <nz-badge nzStandalone [nzCount]="draftLength"
                [nzStyle]="{ backgroundColor: '#fff', color: '#999', boxShadow: '0 0 0 1px #d9d9d9 inset'}"
                class="badge"></nz-badge>
            </li>
            <li nz-menu-item (click)="changeMode('deleted')">
              <i nz-icon nzType="delete"></i>
              Thùng rác
            </li>
            <li nz-submenu nzTitle="Cài đặt mở rộng" nzIcon="setting">
              <ul>
                <li nz-menu-item (click)="changeMode('tags')">
                  <i nz-icon nzType="tag" nzTheme="outline"></i>
                  Quản lý nhãn
                </li>
              </ul>
            </li>
            <li nz-submenu nzTitle="Nhãn" nzIcon="tags">
              <ul>
                <li *ngFor="let tag of tags" nz-menu-item (click)="changeModeInbox('inbox', tag)">
                  <i nz-icon nzType="tag" nzTheme="outline" [style.color]="tag.color"></i>
                  {{ tag.name }}
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div nz-col nzSm="16" nzMd="16" nzLg="19" nzXl="20" #table>
      <ng-container *ngIf="mode === 'tags'">
        <app-tag-list (loadTag)="getTag()"></app-tag-list>
      </ng-container>
      <ng-container *ngIf="mode === 'inbox'">
        <app-mail-list [mode]="mode" [events]="eventsSubject.asObservable()"></app-mail-list>
      </ng-container>
      <ng-container *ngIf="mode === 'outbox'">
        <app-mail-list [mode]="mode"></app-mail-list>
      </ng-container>
      <ng-container *ngIf="mode === 'draft'">
        <app-mail-list [mode]="mode"></app-mail-list>
      </ng-container>
      <ng-container *ngIf="mode === 'deleted'">
        <app-mail-list [mode]="mode"></app-mail-list>
      </ng-container>
    </div>
  </div>
</div>
<ng-template #tplTitle>
  <div class="flex justify-between">
    <span>Soạn thư mới</span>
    <button nz-button class="btn-modal-reside" (click)="handlerResizePopup()">
      <i nz-icon [nzType]="!isResizdePopup ? 'arrows-alt': 'shrink'" nzTheme="outline"></i>
    </button>
  </div>
</ng-template>
